<div class="latest-learning-section-wrapper">
  <div class="tw:mb-2">Recent Activity</div>
  <ul class="tl-links">

    <ng-container>
      @if (lastTargetExists()) {
        <li class="tl-link  tl-link--target" (click)="viewTimeline()"><span>{{learningSection.lastTarget}}</span></li>
      }
      @if (!lastTargetExists()) {
        <li class="tl-link  tl-link--empty" (click)="viewTimeline()"><span>No targets completed</span></li>
      }
      @if (lastProgressExists()) {
        <li class="tl-link  tl-link--progress" (click)="viewTimeline()"><span>{{learningSection.lastProgress}}</span></li>
      }
      @if (!lastProgressExists()) {
        <li class="tl-link  tl-link--empty" (click)="viewTimeline()"><span>No progress to show</span></li>
      }
      @if (lastAssessmentScoreExists()) {
        <li class="tl-link  tl-link--score" (click)="viewTimeline()"><span>{{learningSection.lastAssessmentScore}}</span></li>
      }
      @if (!lastAssessmentScoreExists()) {
        <li class="tl-link  tl-link--empty" (click)="viewTimeline()"><span>No assessment score completed</span></li>
      }
    </ng-container>

    <li class="tl-link  tl-link--view" (click)="viewTimeline()">View full timeline</li>
    <li class="tl-link  tl-link--add" (click)="addLearningSection()">Add a learning section</li>
  </ul>
</div>
